import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import type { ProjectResponse } from './projectStore';

/**
 * Sentral store for current project objektet med alle påkrevde felter.
 * Dette er forutsetningen for å kunne jobbe på /:projectSlug routes.
 */
export const useCurrentProjectStore = defineStore('currentProject', () => {
  // State - holder hele ProjectResponse objektet
  const currentProject = ref<ProjectResponse | null>(null);

  // Actions
  function setCurrentProject (project: ProjectResponse | null) {
    currentProject.value = project;
  }

  // Nullstill ved identitetsendring (logout / konto-bytte, WI 2255).
  function reset (): void {
    currentProject.value = null;
  }

  // Computed properties for enkel tilgang til påkrevde felter
  // Hvis currentProject er satt, er alle felter alltid tilstede (ikke nullable)
  const projectId = computed(() => currentProject.value?.projectId ?? null);
  const projectSlug = computed(() => currentProject.value?.projectSlug ?? null);
  const databaseName = computed(() => currentProject.value?.databaseName ?? null);
  const name = computed(() => currentProject.value?.name ?? null);

  // Helper for å sjekke om prosjekt er satt
  const hasProject = computed(() => currentProject.value !== null);

  return {
    currentProject,
    setCurrentProject,
    reset,
    projectId,
    projectSlug,
    databaseName,
    name,
    hasProject
  };
});
